import React, { useRef, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref,clickOutSide) {
  // const [inside, setInside] = useState(false);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // alert("You clicked outside of me!");
        setTimeout(() => {
          clickOutSide();
        }, 300);
      }
    }
    
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    // document.addEventListener("mouseleave", moveOutside);
    // document.addEventListener("mouseover", moveInside);
    return () => {
      // Unbind the event listener on clean up
      // document.removeEventListener("mouseleave", moveOutside);
      // document.removeEventListener("mouseover", moveInside);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef,props.clickOutSide);
  // const outsideAlerter = document.createElement('div');
  // outsideAlerter.ref = wrapperRef;
  // return <div id="OutsideAlerter" ref={wrapperRef}>{props.children}</div>;
  return <div className={props.className || ''} ref={wrapperRef}>{props.children}</div>;
}